import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './../../../../core/auth/service/auth.service';
import { LayoutUtilsService } from 'src/app/core/_base/crud/utils/layout-utils.service';

@Injectable()
export class AuthEventTokenResolverGuard implements Resolve<any> {
  constructor(
    private service: AuthService,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    if (route.params && route.params.token) {
      return this.service.authEventVerifyToken(route.params.token).pipe(
        catchError((err) => {
          this.layoutUtilsService.showActionNotification({
            title: 'Link inválido',
            text:
              err?.error?.['hydra:description'] ||
              'O link é inválido ou expirou. Por favor, solicite um novo link.',
            icon: 'warning',
            heightAuto: false,
          });

          this.router.navigate(['/auth/login'], {
            queryParams: { c: 'f' },
          });

          //this.router.navigate(['auth/event-invalid-token']);

          return this.clearUser();
        }),
      );
    } else {
      return this.clearUser();
    }
  }

  clearUser() {
    return of({});
  }
}
